// BUILD-046 section B (Owner direction of 2026-10-21): the icon-only Display settings menu, beside the Comfortable / Compact buttons at the right end of the tab row. "Show requester" lives here (it left the Filter panel).
// Persistence is showRequesterStore.ts, unchanged. It applies exactly where it always did (Compact view, never Assigned by Me); elsewhere the checkbox is disabled and says why, so the menu is always in the same place.
import { PopoverButton } from './DropdownMenu';
import { SHOW_REQUESTER_LABEL } from './toolbarModel';

const ICON_BUTTON = "inline-flex h-8 w-9 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a7fb8]";

const SLIDERS_ICON = (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <path d="M3 6h7M15 6h2M3 14h2M9 14h8" />
    <circle cx="12.5" cy="6" r="2" />
    <circle cx="7" cy="14" r="2" />
  </svg>
);

export const DISPLAY_MENU_LABEL = "Display settings";
export const SHOW_REQUESTER_APPLIES_NOTE = "Show requester applies in Compact view, on every tab except Assigned by Me.";

export const SHOW_REQUESTER_COMFORTABLE_LABEL = "Show requester in Comfortable view";
export const SHOW_REQUESTER_COMFORTABLE_NOTE = "Shown under the title by default. Assigned by Me does not repeat you as the requester.";

export interface DisplayMenuProps {
  /** True where Show requester does its work (Compact view, not Assigned by Me). */
  applies: boolean;
  checked: boolean;
  onToggle: () => void;
  /** Owner correction 2026-10-24 (item 4): the Comfortable requester preference (ON by default). Absent: that checkbox is not drawn. */
  comfortable?: { applies: boolean; checked: boolean; onToggle: () => void };
}

export function DisplayMenu({ applies, checked, onToggle, comfortable }: DisplayMenuProps) {
  return (
    <PopoverButton testId="display-menu" buttonText="" ariaLabel={DISPLAY_MENU_LABEL} panelLabel={DISPLAY_MENU_LABEL} icon={SLIDERS_ICON} iconOnly buttonClassName={ICON_BUTTON} align="right" panelClassName="w-64 max-w-[calc(100vw-2rem)]">
      <fieldset data-testid="display-settings">
        <legend className="mb-1.5 text-xs font-semibold text-gray-700">Display</legend>
        {comfortable !== undefined && (
          <>
            <label className={"flex items-center gap-2 rounded px-1 py-0.5 text-sm " + (comfortable.applies ? "cursor-pointer text-gray-800 hover:bg-gray-50" : "text-gray-500")}>
              <input type="checkbox" checked={comfortable.checked} disabled={!comfortable.applies} onChange={() => comfortable.onToggle()} data-testid="display-show-requester-comfortable" className="h-4 w-4 accent-[#1f6fa5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a7fb8]" />
              <span>{SHOW_REQUESTER_COMFORTABLE_LABEL}</span>
            </label>
            <p className="mb-1.5 ml-7 text-xs text-gray-600" data-testid="display-comfortable-note">{SHOW_REQUESTER_COMFORTABLE_NOTE}</p>
          </>
        )}
        <label className={"flex items-center gap-2 rounded px-1 py-0.5 text-sm " + (applies ? "cursor-pointer text-gray-800 hover:bg-gray-50" : "text-gray-500")}>
          <input type="checkbox" checked={checked} disabled={!applies} onChange={() => onToggle()} data-testid="display-show-requester" className="h-4 w-4 accent-[#1f6fa5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a7fb8]" />
          <span>{SHOW_REQUESTER_LABEL}</span>
        </label>
        {!applies && <p className="mt-1 text-xs text-gray-600" data-testid="display-note">{SHOW_REQUESTER_APPLIES_NOTE}</p>}
      </fieldset>
    </PopoverButton>
  );
}

